/* eslint-disable no-console */
import React, { Component } from 'react';
import { formatRoute } from 'react-router-named-routes';
// adopt
import { adopt } from 'react-adopt';
// graphql
import gql from 'graphql-tag';
// global variables
import { localStorageAuthKey as AUTH_TOKEN } from 'config';
// our components
import client from 'client';
import { USER } from 'routes/paths';
import AuthContext from 'helpers/authContext';
import RouterContext from 'helpers/routerContext';
import { Mutation } from 'components/common/Query';
import Logged from 'components/Layout/Logged/Logged';
import i18n from 'i18n';

/**
 * Mutation to logout
 */
export const LOGOUT_MUTATION = gql`
  mutation {
    logout(input: {}) {
      success
    }
  }
`;

/**
 * @class
 * @description Wrapper for Logged component.
 * @extends Component
 */
class LoggedContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.Compose = adopt({
      mutateLogout: this.logout,
      user: this.userContext,
    });
    this.state = {
      language: 'es',
    };
  }

  componentDidMount() {
    i18n.on('languageChanged', this.onLanguageChanged);
  }

  componentWillUnmount() {
    i18n.off('languageChanged', this.onLanguageChanged);
  }

  /**
   * @description
   * Listener when language changed
   * @param {string} lng - Changed language.
   */
  onLanguageChanged = lng => {
    this.setState({ language: lng });
  };

  /**
   * @description
   * Query callback to compose with logout mutation.
   *
   * @param {*} render - Query's render props.
   * @returns {*} AuthContext.
   */
  userContext = ({ render }) => (
    <AuthContext.Consumer>{user => render(user)}</AuthContext.Consumer>
  );

  /**
   * @description
   * Mutation callback to compose with query 'me'.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  logout = ({ render }) => (
    <Mutation mutation={LOGOUT_MUTATION} onCompleted={this.logoutCompleted}>
      {logout => render(logout)}
    </Mutation>
  );

  /**
   * @description
   * OnComplete logout mutation.
   */
  logoutCompleted = async () => {
    const history = this.context;
    localStorage.setItem(AUTH_TOKEN, '');
    client.clearStore();
    history.push(USER.LOGIN);
  };

  /**
   * @description
   * Call to change language
   * @returns {Function} Change language.
   */
  changeLanguage = () => {
    const { language } = this.state;
    if (language === 'es') {
      return i18n.changeLanguage('en');
    }
    return i18n.changeLanguage('es');
  };

  /**
   * @description
   * Render Logged component.
   *
   * @returns {*} Logged component.
   */
  render() {
    const history = this.context;
    return (
      <this.Compose>
        {({ mutateLogout, user }) => (
          <Logged
            user={user}
            changeLanguage={this.changeLanguage}
            logout={mutateLogout}
            viewProfile={() => {
              history.push(
                formatRoute(`${USER.DETAILS}#logs`, { id: user.id }),
              );
            }}
          />
        )}
      </this.Compose>
    );
  }
}

export default LoggedContainer;
